module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Delete-user-97487e36542631091b9c4d08f8abfa79.svg";